import { SxProps, Tooltip, TooltipProps } from '@mui/material'
import React, { CSSProperties } from 'react'

interface ColoredTooltipProps extends TooltipProps {
  title: React.ReactNode
  tooltipSx?: SxProps
  arrowStyle?: CSSProperties
  open?: boolean
  children: React.ReactElement<any, any>
}

const ColoredTooltip = (props: ColoredTooltipProps): JSX.Element => {
  const { title, placement = 'top', tooltipSx, children, arrowStyle, open = false, ...restProps } = props

  if (!title) {
    return children
  }

  return (
    <Tooltip
      title={title}
      PopperProps={
        open
          ? {
              open: true
            }
          : {}
      }
      arrow
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            color: '#fff',
            fontSize: 12,
            fontWeight: 500,
            background: '#000',
            maxWidth: 600,
            padding: '10px',
            ...tooltipSx
          }
        },
        arrow: {
          style: {
            color: '#000',
            ...arrowStyle
          }
        }
      }}
      {...restProps}>
      {children}
    </Tooltip>
  )
}

export default ColoredTooltip
